import { PocCard } from 'commons/components/components-wrapper/poc-card.component';
import { PocProgressSpinner } from 'commons/components/components-wrapper/poc-progress-spinner.component';
import { AddButton } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import { SettingsLoadingContainer } from 'modules/settings/settings.style';
import { ActionOptionItem } from '../components/action-option-item.component';
import { TriggerActionsState } from '../constants/frontend-enums';
import { AutomationRuleOption, OnAddOptionHandlerProps } from '../hooks/use-automation-rule-options-state';
import { AutomationRulesCardLayout } from '../styled/automation-rules.style';
import { ActionsExternalOptions, DeleteOptionParams } from '../types/automation-rules.type';

interface ActionsLayoutProps {
    options: AutomationRuleOption[];
    isLoading: boolean;
    externalOptions: ActionsExternalOptions;
    onAddActionHandler: (data: OnAddOptionHandlerProps) => () => void;
    onDeleteOptionHandler: (data: DeleteOptionParams) => () => void;
}

export const ActionsLayout = (props: ActionsLayoutProps) => {
    const { options, isLoading, externalOptions, onAddActionHandler, onDeleteOptionHandler } = props;

    const { t } = useTranslation();
    return (
        <PocCard rounded>
            <AutomationRulesCardLayout className="col-dir">
                {isLoading ? (
                    <SettingsLoadingContainer>
                        <PocProgressSpinner variant="primary" size="large" />
                    </SettingsLoadingContainer>
                ) : (
                    <>
                        {options?.map((el, index) => {
                            const optionsLength = options.length;
                            const { content, id } = el;
                            return (
                                <ActionOptionItem
                                    key={el.id}
                                    id={id}
                                    content={content}
                                    index={index}
                                    optionsLength={optionsLength}
                                    externalOptions={externalOptions}
                                    onDeleteOptionHandler={onDeleteOptionHandler}
                                />
                            );
                        })}
                        <AddButton
                            text={t('settings.system.automation-rules.logical-operators.add-action')}
                            onClick={onAddActionHandler({ parentArrayName: TriggerActionsState.actions })}
                        />
                    </>
                )}
            </AutomationRulesCardLayout>
        </PocCard>
    );
};
